import { useState } from "react"
import {
    Menu,
    Typography,
    Button,
    Card,
    Switch,
    Select,
    DatePicker,
    Table,
    Input,
    Dropdown,
    message,
    Tag,
} from "antd"
import {
    DownloadOutlined,
    SearchOutlined,
} from "@ant-design/icons"

const { Title, Text } = Typography
const { Option } = Select
const { RangePicker } = DatePicker

// Helper for Ant Design message
const showMessage = (type, content) => {
    message[type](content)
}

const AuditLog = () => {
    const [dateRange, setDateRange] = useState(null)
    const [actionTypeFilter, setActionTypeFilter] = useState(null)
    const [userFilter, setUserFilter] = useState(null)
    const [liveView, setLiveView] = useState(false)

    const auditLogData = [
        {
            key: "1",
            timestamp: "June 15, 2025 09:32 AM",
            actionType: "Execution Fired",
            performedBy: "System",
            description: "Auto-task pushed to Asana",
            undoOption: false,
        },
        {
            key: "2",
            timestamp: "June 15, 2025 09:30 AM",
            actionType: "Config Change",
            performedBy: "Admin@company.com",
            description: "Changed notification frequency to Daily",
            undoOption: true,
        },
        {
            key: "3",
            timestamp: "June 14, 2025 08:45 PM",
            actionType: "Login",
            performedBy: "ellie@company.com",
            description: "User logged in from IP 192.168.1.100",
            undoOption: false,
        },
        {
            key: "4",
            timestamp: "June 14, 2025 08:00 PM",
            actionType: "User Management",
            performedBy: "Admin@company.com",
            description: "Invited new user: jane@company.com",
            undoOption: true,
        },
    ]

    const columns = [
        { title: "Timestamp", dataIndex: "timestamp", key: "timestamp" },
        {
            title: "Action Type",
            dataIndex: "actionType",
            key: "actionType",
            render: (text) => {
                let color = "blue"
                if (text === "Execution Fired") color = "green"
                if (text === "Config Change") color = "geekblue"
                if (text === "Login") color = "purple"
                return <Tag color={color}>{text}</Tag>
            },
        },
        { title: "Performed By", dataIndex: "performedBy", key: "performedBy" },
        { title: "Description", dataIndex: "description", key: "description" },
        {
            title: "Undo Option",
            dataIndex: "undoOption",
            key: "undoOption",
            render: (text) => (text ? <Button size="small">Undo</Button> : "-"),
        },
    ]

    const exportMenu = (
        <Menu onClick={({ key }) => showMessage("success", `Exporting as ${key}`)}>
            <Menu.Item key=".csv">.csv</Menu.Item>
            <Menu.Item key=".json">.json</Menu.Item>
        </Menu>
    )

    return (
        <Card className="mb-6">
            <div className="mb-4">
                <Title level={4}>Audit Log</Title>
                <Text type="secondary">See a full history of settings changes, executions, and access activity.</Text>
            </div>

            <div className="flex flex-wrap gap-4 mb-6 items-center">
                <RangePicker onChange={setDateRange} value={dateRange} />
                <Select placeholder="Filter by Action Type" allowClear onChange={setActionTypeFilter} className="w-48">
                    <Option value="Execution Fired">Execution Fired</Option>
                    <Option value="Config Change">Config Change</Option>
                    <Option value="Login">Login</Option>
                    <Option value="User Management">User Management</Option>
                </Select>
                <Input
                    placeholder="Filter by User"
                    prefix={<SearchOutlined />}
                    onChange={(e) => setUserFilter(e.target.value)}
                    className="w-48"
                />
                <Dropdown overlay={exportMenu} placement="bottomRight">
                    <Button icon={<DownloadOutlined />}>Export Audit Log</Button>
                </Dropdown>
                <div className="flex items-center ml-auto">
                    <Text className="mr-2">Live View</Text>
                    <Switch checked={liveView} onChange={setLiveView} />
                </div>
            </div>

            <Table dataSource={auditLogData} columns={columns} pagination={{ pageSize: 5 }} />
        </Card>
    )
}

export default AuditLog;